import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Box, Typography, Card, TextField, Stack, Avatar } from "@mui/material";
import { useParams } from "react-router-dom";
import "../../../assets/styles/Bidding/LiveBiddingTab.css";
import { BACKEND_DOMAIN } from "../../../common/env";

const UserLiveBiddingTab = () => {
  const { auctionId } = useParams();

  // YouTube video state
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [auction, setAuction] = useState(null);

  // Helper function to extract YouTube video ID from URL
  const extractYouTubeId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  // Fetch auction details to get YouTube URL
  useEffect(() => {
    const fetchAuctionDetails = async () => {
      try {
        const response = await axios.get(`${BACKEND_DOMAIN}/auctions/${auctionId}`);
        setAuction(response.data);
        if (response.data.liveAuctionLink) {
          setYoutubeUrl(response.data.liveAuctionLink);
          const videoId = extractYouTubeId(response.data.liveAuctionLink);
          setIsVideoLoaded(!!videoId);
        }
      } catch (error) {
        console.error("Error fetching auction details:", error);
      }
    };

    fetchAuctionDetails();
  }, [auctionId]);

  // Only render the video if it's loaded
  if (isVideoLoaded) {
    return (
      // Removed padding to work with table-like layout
      <div style={{ width: "100%" }}>
        {/* YouTube Video Section */}
        <Box className="youtube-video-container full-width">
          {/* YouTube Video Embed */}
          <Card 
            className="youtube-video-card"
            sx={{ 
              width: '100%',
              maxWidth: '100%',
              margin: '0 auto',
              borderRadius: { xs: '8px', sm: '10px', md: '12px' },
              boxShadow: '0 12px 40px rgba(0, 0, 0, 0.3)',
              overflow: 'hidden'
            }}
          >
            <Box 
              className="youtube-video-wrapper"
              sx={{ 
                position: 'relative',
                width: '100%',
                paddingBottom: '56.25%', // 16:9 aspect ratio
                height: 0
              }}
            >
              <iframe
                src={`https://www.youtube.com/embed/${extractYouTubeId(youtubeUrl)}?autoplay=1&rel=0&modestbranding=1`}
                title="Live Auction Stream"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="youtube-video-iframe"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
              />
            </Box>
          </Card>
        </Box>
      </div>
    );
  }

  // If video is not loaded, render nothing (redirect will happen in parent component)
  return null;
};

export default UserLiveBiddingTab;